// extracted by mini-css-extract-plugin
export default {"messages_list":"MessageList_messages_list__Ko7VN","full-height":"MessageList_full-height__ebJD7","chat-typing":"MessageList_chat-typing__Ly6p1"};